// USCIRE CON INVIO DEVE SEMBRARE UN CLIC FUORI. Il campo perde il fuoco, ma il puntatore è ancora
// lì sopra e la cornice dell'hover si ridisegna subito: a vederlo, il campo è ancora in modifica.
// Chi esce con la tastiera segna il campo, e la cornice torna solo quando il puntatore se ne va e
// ci ripassa — o quando il campo riprende il fuoco. Lo usano il nome nella testata dell'Inspector
// dello Scene Editor e quello del Composer: un tasto, un gesto, nei due editor.

/** Il selettore che spegne l'hover dopo un'uscita da tastiera: `&:hover:not(:focus):not(${LEFT_BY_KEYBOARD})`. */
export const LEFT_BY_KEYBOARD = '[data-left-by-keyboard]';

export const leaveInlineField = (field: HTMLInputElement) => {
    field.setAttribute('data-left-by-keyboard', '');
    field.blur();
};

/** Da chiamare sull'uscita del puntatore e sul fuoco: il campo torna a rispondere all'hover. */
export const rearmInlineField = (field: HTMLElement) => field.removeAttribute('data-left-by-keyboard');
